<template>
  <layout :titlePage="'Minha carteira'">
    <section class="c-wallet-pending">
      <div class="c-wallet-pending__container">
        <base-icon name="error-page" width="160px" height="130px" />
        <div v-if="unavailableReason == 'permission'">
          <p class="c-wallet-pending__message">
            Ops! Você não possui permissão para acessar esta página...
            <br />
            Para mais informações, entre em contato com o nosso atendimento 😉
          </p>
        </div>
        <div v-else>
          <p class="c-wallet-pending__message">
            Não foi possível carregar<br />seus dados no momento!
          </p>
          <router-link
            class="button is-outlined is-gray-outlined"
            :to="{ name: 'carteira' }"
          >
            Recarregar página
          </router-link>
        </div>
      </div>
    </section>
  </layout>
</template>
<script>
import loadingViewMixin from '@/mixins/loadingViewMixin'
import layout from '@/layouts/Default.vue'

export default {
  mixins: [loadingViewMixin],

  components: {
    layout,
  },

  computed: {
    unavailableReason() {
      return this.$route.query.reason
    },
  },

  mounted() {
    this.loading = false
  },
}
</script>

<style lang="scss">
.c-wallet-pending {
  position: relative;
  height: calc(100vh - 111px);
  text-align: center;

  &__container {
    @include position(absolute, 50%, 0, 0, 0, -50%);
  }

  &__message {
    margin: 24px 6px;
  }
}
</style>
